SpinJS = require('spin.js')

imgDirective = (el, binding, vnode) ->
  return unless binding.value != binding.oldValue

  event   = new CustomEvent('imageLoading')
  el.dispatchEvent(event)

  img         = new Image()
  img.src     = binding.value
  el.src      = ''
  img.onload  = ->
    el.src  = binding.value
    event   = new CustomEvent('imageLoaded', { detail: { width: img.width, height: img.height } })
    el.dispatchEvent(event)

spinJsOptions = {
  lines: 11             # The number of lines to draw
  length: 12            # The length of each line
  width: 2              # The line thickness
  radius: 8             # The radius of the inner circle
  scale: 1              # Scales overall size of the spinner
  corners: 1            # Corner roundness (0..1)
  color: '#fff'         # #rgb or #rrggbb or array of colors
  opacity: 0.25         # Opacity of the lines
  rotate: 0             # The rotation offset
  direction: 1          # 1: clockwise, -1: counterclockwise
  speed: 1              # Rounds per second
  trail: 60             # Afterglow percentage
  fps: 20               # Frames per second when using setTimeout() as a fallback for CSS
  zIndex: 2e9           # The z-index (defaults to 2000000000)
  className: 'spinner'  # The CSS class to assign to the spinner
  top: '50%'            # Top position relative to parent
  left: '50%'           # Left position relative to parent
  shadow: false         # Whether to render a shadow
  hwaccel: false        # Whether to use hardware acceleration
  position: 'absolute'  # Element positioning
}

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  mixins: [
    require('shared/mixins/vue/window_key_listener_mixin')
  ]

  data: ->
    loading:        false
    zoomed:         false
    mouseDown:      false
    dragging:       false
    dragCoord:      { x: 0, y: 0 }
    imageStyle:     {}
    imageBoxStyle:  {}

  directives:

    img:
      bind:   imgDirective
      update: imgDirective

    spinJsSpinner:
      bind: (el, binding, vnode) ->
        binding.spinner = new SpinJS(spinJsOptions)
        binding.spinner.spin(el)
      unbind: (el, binding, vnode) ->
        binding.spinner.stop() if binding.spinner?
        binding.spinner = null

  computed:

    isOpen: ->
      @openedCollection? && @openedItem?

    isZoomable: ->
      return false if @loading
      return false unless @.$refs.currentImage

      @.$refs.currentImage.offsetWidth < @.$refs.currentImage.naturalWidth || @.$refs.currentImage.offsetHeight < @.$refs.currentImage.naturalHeight

    isZoomed: ->
      @zoomed == true

    openedCollection: ->
      @.$store.state.lightbox.openedCollection

    openedItem: ->
      @.$store.state.lightbox.openedItem

    openedData: ->
      @.$store.getters['lightbox/current'] || {}

    openedUrl: ->
      @openedData.imageUrl || null

    openedTitle: ->
      @openedData.title || null

    normalizedImageBoxStyle: ->
      if @isZoomable && @isZoomed then {} else @imageBoxStyle

    normalizedImageStyle: ->
      if @isZoomable && @isZoomed then {} else @imageStyle

    hasPreviousItem: ->
      @.$store.getters['lightbox/hasPreviousItem'] == true

    hasNextItem: ->
      @.$store.getters['lightbox/hasNextItem'] == true

    previousItemData: ->

    nextItemData: ->

  methods:

    close: ->
      @.$store.dispatch('lightbox/close')

    onKeyupEsc: ->
      @close()

    onClickClose: ->
      @close()

    onKeyupLeft: ->
      @.$store.dispatch('lightbox/openPrevious')

    onKeyupRight: ->
      @.$store.dispatch('lightbox/openNext')

    onCurrentImageLoading: ->
      @.$set @, 'zoomed', false
      @.$set @, 'loading', true

    onCurrentImageLoaded: (event) ->
      @.$set @, 'zoomed', false
      @.$set @, 'loading', false
      @resetImageSize()
      @.$nextTick => @updateImageContainerSize(event.detail.width, event.detail.height)

    onCurrentImageClick: ->
      return unless @isZoomable

      @.$set @, 'zoomed', @zoomed == false

    onClickPrevious: ->
      @.$store.dispatch('lightbox/openPrevious')

    onClickNext: ->
      @.$store.dispatch('lightbox/openNext')

    onMouseDown: (event) ->
      @.$set @, 'mouseDown', true

    onMouseUp: (event) ->
      @.$set @, 'mouseDown', false

      @onCurrentImageClick() unless @dragging == true

      @.$set @, 'dragging', false
      @.$set @, 'dragCoord', { x: 0, y: 0 }

    onMouseMove: (event) ->
      return unless @mouseDown == true

      if @dragging == true
        diff = @dragCoord.x - event.offsetX
        @.$refs.currentImageBox.scrollLeft = @.$refs.currentImageBox.scrollLeft + diff
      else
        @.$set @, 'dragging', true
        @.$set @, 'dragCoord', { x: event.offsetX, y: event.offsetY }

    resetImageSize: ->
      @.$set @, 'imageStyle', {}

    updateImageContainerSize: (width, height) ->
      style = { height: height, width: width }

      if @.$refs.currentImageContainer.clientHeight < style.height
        style.height  = @.$refs.currentImageContainer.clientHeight
        style.width   = parseInt(style.height / height * width)

      if @.$refs.currentImageContainer.clientWidth < style.width
        style.width   = @.$refs.currentImageContainer.clientWidth
        style.height  = parseInt(style.width / width * height)

      @.$set @, 'imageBoxStyle', {
        height: "#{style.height}px"
        width:  "#{style.width}px"
      }
      @.$nextTick => @updateImageSize(style.width, style.height)

    updateImageSize: (width, height) ->
      @.$set @, 'imageStyle', { height: "#{height}px", width: "#{width}px" }

    updateBodyTagClass: ->
      bodyTag = document.getElementsByTagName('body')[0]
      bodyTag.setAttribute('class', if @isOpen then 'comp-lightbox-open' else '')

  watch:

    openedCollection: ->
      @updateBodyTagClass()

    openedItem: ->
      @updateBodyTagClass()



// WEBPACK FOOTER //
// ./assets/js/frontend/components/lightbox/index.coffee